import React, { useEffect, useState } from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { useNav } from '../../../../providers/NavProvider';
import { useClient } from '../../../../providers/ClientProvider';
import { useAuth } from '../../../../providers/AuthProvider';
import { findProjectParent, getComplianceConfig } from './dataOperations';
import { ISitee } from '../../../ClientLanding';

interface complianceProps {
    logTitle: string;
    siteId: string;
}
const ComplianceTable: React.FC<complianceProps> = ({ logTitle, siteId }) => {

    const { sitesResp } = useNav();
    const { clientAPIURL } = useClient();
    const { accessToken } = useAuth();
    const [complianceConfig, setComplianceConfig] = useState<any>()
    useEffect(() => {
        async function getCompliance() {
            const projectSite: ISitee = findProjectParent(sitesResp, siteId);
            const compliance: any = await getComplianceConfig(clientAPIURL, accessToken, projectSite.id)
            setComplianceConfig(compliance)
        }
        getCompliance();
    }, [])
    const noiseCompliance = complianceConfig && complianceConfig.noise;
    const otherLimits = complianceConfig && { ...complianceConfig };
    otherLimits && delete otherLimits.noise; // Remove noise to handle separately

    return (
        <ScrollView>
            <View style={styles.container}>

                {/* Noise Compliance Table */}

                {complianceConfig && logTitle && logTitle === "Noise Monitoring Log" ?
                    <ScrollView horizontal contentContainerStyle={{flexDirection: 'column'}}>
                        <View>
                            <Text style={styles.title}>Noise Compliance Levels</Text>
                        </View>

                        <View style={styles.table}>
                            <View style={[styles.row, styles.header]}>
                                <Text style={[styles.cell, styles.headerText]}>Time Period</Text>
                                <Text style={[styles.cell, styles.headerText]}>Location Type</Text>
                                <Text style={[styles.cell, styles.headerText]}>Compliance (dBA)</Text>
                            </View>

                            {/* Apply vertical scroll within a fixed height */}
                            <ScrollView style={styles.scrollContainer}>
                                {Object.entries(noiseCompliance).map(([timePeriod, locations]) =>
                                    Object.entries(locations as Record<string, number>).map(([location, value], index) => (
                                        <View key={`${timePeriod}-${location}`} style={styles.row}>
                                            <Text style={styles.cell}>{index === 0 ? timePeriod : ''}</Text>
                                            <Text style={styles.cell}>{location}</Text>
                                            <Text style={styles.cell}>{value}</Text>
                                        </View>
                                    ))
                                )}
                            </ScrollView>
                        </View>
                    </ScrollView>
                    :

                    complianceConfig && logTitle && logTitle === "PM10 Monitoring Log" ?
                        <View style={styles.table}>
                            <View key='pm10' style={styles.row}>
                                <Text style={styles.cell}>Compliance Limit for PM10 = {otherLimits.pm10}</Text>
                            </View>
                        </View>
                        :
                        complianceConfig && logTitle === "PM2.5 Monitoring Log" ?
                            <View style={styles.table}>
                                <View key='pm2p5' style={styles.row}>
                                    <Text style={styles.cell}>Compliance Limit for PM2.5 = {otherLimits.pm2p5}</Text>
                                </View>
                            </View>
                            : complianceConfig && logTitle === "Vibration Monitoring Log" ?
                                <View style={styles.table}>
                                    <View key='vibration' style={styles.row}>
                                        <Text style={styles.cell}>Compliance Limit for Vibration {otherLimits.vibration}</Text>
                                    </View>
                                </View>
                                : null

                }
            </View>
        </ScrollView>
    );
};

export default ComplianceTable;
const styles = StyleSheet.create({
    container: {
        padding: 10,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginVertical: 10,
        //textAlign: 'center',
    },
    table: {
        borderWidth: 1,
        borderColor: '#ccc',
        borderRadius: 5,
        marginBottom: 20,
        width: '100%',
    },
    scrollContainer: {
        maxHeight: 100, // Ensure the height is limited
    },
    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#000000',
    },
    header: {
        backgroundColor: '#4BB75F',
    },
    headerText: {
        fontWeight: 'bold',
        color: 'white',
    },
    cell: {
        flex: 1,
        padding: 10,
        textAlign: 'center',
        //borderRightWidth: 1,
        //borderColor: '#000000',
    },
});

